import { useTranslation } from 'react-i18next';
import bonusImage from '../../assets/images/bonus-image.webp';
import { InfoItem } from './components/InfoItem';
import { BonusData } from '../../types';

const REFFERAL_BONUS_TYPE = 3;
export const Content = ({ amount, maxBet, wager, freeSpinBet, name, type }: BonusData) => {
  const { t } = useTranslation();
  const bonusName = type === REFFERAL_BONUS_TYPE ? t('bonusModal.bonusName') : name;

  return (
    <>
      <img src={bonusImage} draggable={false} className="object-cover h-[128px]" alt="bonus gift" />
      <div className="w-full text-center flex flex-col gap-2 px-4 412:px-7 py-6">
        <p className="text-bm_title text-xl font-bold uppercase">
          {t('bonusModal.claimYourBonus')}
        </p>
        {Boolean(bonusName) && <p className="text-bm_text font-medium leading-5">{bonusName}</p>}
        {Boolean(amount) && (
          <p className="text-bm_text text-[32px] leading-10 font-bold uppercase">{amount}</p>
        )}

        <div className="w-full flex gap-1 items-center empty:hidden">
          {maxBet && <InfoItem title={t('bonusModal.maxBet')} content={maxBet} />}
          {wager && <InfoItem title={t('bonusModal.wager')} content={wager} />}
          {freeSpinBet && <InfoItem title={t('bonusModal.FSbet')} content={freeSpinBet} />}
        </div>
      </div>
    </>
  );
};
